import {
  QrCode,
  QrCodePageQuery,
  QrCodeResource,
  QrCodeResourcePage,
  QrCodeResourcePayload,
  PageOf
} from '@/models'

import {
  generateCreate,
  generateDelete,
  generateRead,
  generateReadPage,
  generateUpdate
} from '../crudGenerator'

/**
 * Converts QrCodeResource to QrCode.
 *
 * @param resource Reponse data to be converted.
 */
export function parseQrCodeResource (resource: QrCodeResource): QrCode {
  return {
    id: resource.id,
    businessUnitId: resource.shopId, // Renaming
    location: resource.locationName, // Renaming
    code: resource.code,
    isPrepaid: resource.prepay, // Renaming
    isActive: resource.active // Renaming
  }
}

/**
 * Converts QrCodeResourcePage to PageOf<QrCode>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseQrCodeResourcePage (page: QrCodeResourcePage): PageOf<QrCode> {
  return {
    elements: page.qrcodes.map(parseQrCodeResource),
    total: page.count
  }
}

const url = '/menu'
const entity = 'qrcodes'

export default {
  /**
   * Creates a new QrCode.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param payload Data required to create it.
   */
  createQrCode: generateCreate<QrCode, QrCodeResource, QrCodeResourcePayload>(url, entity, parseQrCodeResource),

  /**
   * Deletes a QrCode.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id QrCode id to be deleted.
   */
  deleteQrCode: generateDelete(url, entity),

  /**
   * Gets a QrCode.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id QrCode id to be fetched.
   */
  fetchQrCode: generateRead(url, entity, parseQrCodeResource),

  /**
   * Gets a page of QrCodes.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param query Query QrCodes.
   */
  fetchQrCodePage: generateReadPage<QrCode, QrCodeResourcePage, QrCodePageQuery>(url, entity, parseQrCodeResourcePage),

  /**
   * Updates an existing QrCode.
   *
   * @param tokenV2 Valid token with an AccountId.
   * @param id QrCode id to be updated.
   * @param payload Data required to create it.
   */
  updateQrCode: generateUpdate<QrCode, QrCodeResource, QrCodeResourcePayload>(url, entity, parseQrCodeResource)
}
